var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.667,
    height: 26.036,
    viewBox: "0 0 28.667 26.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12748",
    "data-name": "Group 12748",
    transform: "translate(230.502 -110.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    d: "M-143.924,156.016c0-1.912,0-3.717,0-5.522,0-2.043.775-3.119,2.231-3.089,1.414.028,2.149,1.069,2.152,3.062,0,2.107.013,4.213,0,6.32-.015,1.921-.806,2.684-2.732,2.719-1.01.018-2.306-.3-2.949.206s-.649,1.838-.911,2.815c-.141.525-.212,1.067-.352,1.592a1.728,1.728,0,0,1-2.066,1.323,1.66,1.66,0,0,1-1.325-1.949c.326-2.042.675-4.082,1.074-6.111a1.623,1.623,0,0,1,1.727-1.363C-146.1,156.006-145.12,156.016-143.924,156.016Z",
    transform: "translate(-62.997 -28.48)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    d: "M-222.91,156.018c1.045,0,1.981-.015,2.915,0a1.738,1.738,0,0,1,2.006,1.687q.51,2.734.972,5.477c.207,1.232-.294,2.076-1.295,2.266-1.071.2-1.835-.418-2.117-1.67-.264-1.169-.615-2.321-.835-3.5-.124-.664-.449-.806-1.045-.782-.872.035-1.747.028-2.619,0a2.17,2.17,0,0,1-2.347-2.306c-.034-2.474-.03-4.949,0-7.423a2.179,2.179,0,0,1,2.178-2.359,2.238,2.238,0,0,1,2.176,2.387c.036,1.673.01,3.347.012,5.021C-222.909,155.175-222.91,155.53-222.91,156.018Z",
    transform: "translate(-2.505 -28.486)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8446",
    "data-name": "Path 8446",
    d: "M-175.024,146.33h-7.762a27.556,27.556,0,0,1,.035-3.8,2.185,2.185,0,0,1,2.912-1.838,4.492,4.492,0,0,0,1.82,0,2.268,2.268,0,0,1,2.98,2.14C-174.961,143.951-175.024,145.078-175.024,146.33Z",
    transform: "translate(-37.255 -23.171)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8447",
    "data-name": "Path 8447",
    d: "M-177.13,187.007h5.315c-.084.967-.159,1.886-.243,2.805-.145,1.588-.272,3.177-.453,4.761a2,2,0,0,1-1.9,1.767,1.98,1.98,0,0,1-1.966-1.573C-176.672,192.221-176.879,189.665-177.13,187.007Z",
    transform: "translate(-41.717 -59.435)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8448",
    "data-name": "Path 8448",
    d: "M-198.728,174.026a4.5,4.5,0,0,1,.032-1.33c.095-.283.483-.663.744-.665,4.571-.04,9.142-.029,13.811-.029.065.679.125,1.306.193,2.024Z",
    transform: "translate(-24.809 -47.706)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8449",
    "data-name": "Path 8449",
    d: "M-122.812,115.855a2.892,2.892,0,0,1,2.842,2.955,2.89,2.89,0,0,1-3,2.791,2.888,2.888,0,0,1-2.79-2.9A2.889,2.889,0,0,1-122.812,115.855Z",
    transform: "translate(-81.867 -3.82)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8450",
    "data-name": "Path 8450",
    d: "M-227.641,115.848a2.9,2.9,0,0,1,2.921,2.879,2.9,2.9,0,0,1-2.927,2.872,2.866,2.866,0,0,1-2.855-2.824A2.869,2.869,0,0,1-227.641,115.848Z",
    transform: "translate(0 -3.815)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8451",
    "data-name": "Path 8451",
    d: "M-175.15,116.662a2.862,2.862,0,0,1-2.841-2.835,2.871,2.871,0,0,1,2.929-2.86,2.828,2.828,0,0,1,2.767,2.892A2.817,2.817,0,0,1-175.15,116.662Z",
    transform: "translate(-41.044)",
    fill: "#37bdb0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityManagement);
export default __webpack_public_path__ + "static/media/Facility_Management.0b960c97a0386f911ea6e9383eabe19c.svg";
export { ForwardRef as ReactComponent };